import React from 'react'
import { Button, Dropdown } from 'semantic-ui-react'
import {withRouter} from 'react-router';

const options = [
            { key : '0',value : 'a',text: 'CA and Accounting' },
            { key : '1',value : 'b',text: 'Data Science' },
            { key : '2',value : 'c',text: 'Designing and Drafting' },
            { key : '3',value : 'd',text: 'Digital Marketing' },
            { key : '4',value : 'e',text: 'Engineering' },
            { key : '5',value : 'f',text: 'Event Management' },
            { key : '6',value : 'g',text: 'Food and Catering' },
            { key : '7',value : 'h',text: 'Freelancing' },
            { key : '8',value : 'i',text: 'Graphic Designing' },
            { key : '9',value : 'j',text: 'Human Resources'},
            { key : '10',value : 'k',text: 'Interior Designing'},
            { key : '11',value : 'l',text: 'Machining'},
            { key : '15',value : 'p',text: 'Printing'},
            { key : '12',value : 'm',text: 'Production Man Power'},
            { key : '13',value : 'n',text: 'Tools and Materials'},
            { key : '14',value : 'o',text: 'Web Development'},
            { key : '16',value : 'q',text: 'Others'},
        ]

class Search extends React.Component{
    

    getService=(e)=>{
        if(e.target.textContent.length < 23)
        this.props.history.push(`/services/${e.target.textContent}`)            
    }

    render(){

        return (
            <Button.Group size="tiny"  >
            <Button size="tiny" >Quick Search</Button>
            <Dropdown
                className='button icon'
                floating
                defaultValue="CA and Accounting"
                options={options}
                trigger={<></>}
                scrolling
                onChange={(e)=>this.getService(e)}
            />
          </Button.Group>
        
        )
    }
}


export default withRouter(Search)
